import PropTypes from "prop-types";

export const propTypes = {
    label: PropTypes.string,
    link: PropTypes.string,
    description: PropTypes.string,
};
